import { render } from "./RatingSummarySection.vue?vue&type=template&id=48e27c1e"
import script from "./RatingSummarySection.vue?vue&type=script&lang=js"
export * from "./RatingSummarySection.vue?vue&type=script&lang=js"

import "./RatingSummarySection.vue?vue&type=style&index=0&id=48e27c1e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__